export default {
  title: 'Manage account',
  buttons: {
    save: 'Save',
    delete: 'Delete',
  },
};
